module.exports = __webpack_public_path__ + "static/img/bairun-logo.b6e4d076.jpg";